// baseCode
import PropTypes from "prop-types";
import React from "react";

import { connect } from "react-redux";
import { Link } from "react-router-dom";

import ProfileMenu from "../../components/CommonForBoth/TopbarDropdown/ProfileMenu";

import logoSmall from "../../assets/images/app/common/aou-logo-sm.svg";
import logo from "../../assets/images/app/common/aou-logo-white.svg";

//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import { toggleLeftmenu, changeSidebarType, toggleLeftmenuCollapse } from "../../store/actions";

const Header = (props) => {
  function tToggle() {
    props.toggleLeftmenuCollapse(!props.leftMenuCollapsed);
  }
  return (
    <>
      <header id="page-topbar" className="gt-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box  d-md-block ">
              <Link to="/" className="logo logo-light">
                {/* Logo will be change with casita */}
                <span className="logo-sm ">
                  <img src={logoSmall} alt="Logo" width={40} height={38} />
                </span>
                <span className="logo-lg">
                  <img src={logo} alt="Logo" height={35} width={237} />
                </span>
              </Link>
            </div>
            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 header-item "
              id="vertical-menu-btn"
            >
              <i className="bx bx-bar-chart bx-rotate-90 bx-sm"></i>
            </button>
          </div>
          <div className="d-flex">
            <ProfileMenu />
          </div>
        </div>
      </header>
    </>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
  toggleLeftmenuCollapse: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { layoutType, leftMenu, leftSideBarType, leftMenuCollapsed } = state.Layout;
  return {
    layoutType,
    leftMenu,
    leftSideBarType,
    leftMenuCollapsed,
  };
};

export default connect(mapStatetoProps, {
  toggleLeftmenu,
  changeSidebarType,
  toggleLeftmenuCollapse,
})(withTranslation()(Header));
